// extracted by mini-css-extract-plugin
module.exports = {"consultancyPage":"styles_consultancyPage__D12AX","consultancyImage":"styles_consultancyImage__PCZ99"};